import React from "react";
import { Box, keyframes } from "@mui/material";
import StepUpSpinner from "../Loader/StepUpSpinner";

interface LoadingDialogProps {
  open: boolean;
  title?: string;
  message?: string;
}

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const LoadingPage: React.FC<LoadingDialogProps> = ({ open, title, message }) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "28vh",
        animation: `${fadeIn} 0.3s ease-out`,
        py: 4,
      }}
    >
      <StepUpSpinner size="large" label={title || message || "Loading"} />
    </Box>
  );
};

export default LoadingPage;
